import HundredBricksAPIError from '../../../HundredBricksAPIError';
class VolumeDiscountsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('VolumeDiscountsError', ...args);
    }
}
export default VolumeDiscountsError;
